import React from "react";
import Lottie from "lottie-react";
import bgAnimation from "../assets/Gradient Animated Background.json"

const BackgroundLottie = () => {
  return (
    <div className="lottie-bg">
      <Lottie
        animationData={bgAnimation}
        loop
      />
    </div>
  );
};

export default BackgroundLottie;
